<template>
  <div class="card shadow-sm border border-light mb-4">
    <div class="p-3 pb-0 card-header">
      <h6 class="mb-0">İşlərin mərhələlərə görə bölgüsü</h6>
    </div>
    <div class="p-3 card-body">
      <div class="row">
        <div class="text-center col-5">
          <pie-chart
            :id="'stage-pie'"
            :height="'200'"
            :chart="chartData"
            :key="chartKey"
          />
        </div>
        <div class="col-7">
          <div class="table-responsive">
            <table class="table mb-0 align-items-center">
              <tbody>
                <tr v-for="(item, index) in stageStats" :key="index">
                  <td>
                    <div class="px-2 py-0 d-flex">
                      <span
                        :style="{
                          backgroundColor: colors[index],
                          display: 'inline-block',
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          marginTop: '6px',
                        }"
                        class="me-2"
                      ></span>
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{ item.stageName }}</h6>
                      </div>
                    </div>
                  </td>
                  <td class="text-sm text-center align-middle">
                    <span class="text-xs font-weight-bold">{{ item.caseCount }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from "@/examples/Charts/PieChart.vue";
import { GetStageStats } from "@/project/Source/stats.js";

export default {
  name: "CasesByStagePie",
  components: { PieChart },
  data() {
    return {
      stageStats: [],
      chartKey: 0,
      colors: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#888888"]
    };
  },
  computed: {
    chartData() {
      if (!this.stageStats.length) {
        return {
          labels: [],
          datasets: {
            label: "Mərhələlər",
            data: [],
            backgroundColor: []
          }
        };
      }
      return {
        labels: this.stageStats.map(x => x.stageName),
        datasets: {
          label: "Mərhələlər",
          data: this.stageStats.map(x => x.caseCount),
          backgroundColor: this.colors.slice(0, this.stageStats.length)
        }
      };
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const res = await GetStageStats();
        this.stageStats = res.data.data || [];
        this.chartKey++; 
      } catch (e) {
        console.error("Stage stats yüklenmedi:", e);
      }
    }
  }
};
</script>
